import { gql } from "@apollo/client";

export default gql`
	mutation ($receipt: String!, $lineItemId: Int!, $language: String!) {
		resendShippingNotice(receipt: $receipt, lineItemId: $lineItemId, language: $language)
	}
`;
